var exports = {
  "kL": "x234b8571--a3b8c0--container",
  "Qs": "x234b8571--a3b8c0--content",
  "u1": "x234b8571--a3b8c0--spinner",
};

module.exports = exports;
